
html = ""; 
for (region in makes)
{
  html += '<option value="' + region + '">' + region + '</option>';
}

document.getElementById("make").innerHTML = document.getElementById("make").innerHTML + html;

function set_make(make, model, year, series) {
  var makeArr;
  model.length = 0;
  model.options[0] = new Option('Select Model', '');
  
  year.length = 0;
  year.options[0] = new Option('Select Year', '');
  
  series.length = 0;
  series.options[0] = new Option('Select Series', '');
  
  var makeText = make.options[make.selectedIndex].text;
  if (makes[makeText]) 
  {
    model.disabled = false;
    year.disabled = true;
    series.disabled = true;
    
    makeArr = makes[makeText].split('|');
    for (var i = 0; i < makeArr.length; i++)
      model.options[i + 1] = new Option(makeArr[i], makeArr[i]);
  } 
  else 
  {
    model.disabled = true;
    year.disabled = true;
    series.disabled = true;
  }
}

function set_model_year(model, year, series) {
  var model_yearArr;
  
  year.length = 0;
  year.options[0] = new Option('Select Year', '');
  
  series.length = 0;
  series.options[0] = new Option('Select Series', '');
  
  var modelText = model.options[model.selectedIndex].text;
  if (model_years[modelText]) {
    year.disabled = false;
    
    model_yearArr = model_years[modelText].split('|');
    for (var i = 0; i < model_yearArr.length; i++)
      year.options[i + 1] = new Option(model_yearArr[i], model_yearArr[i]);
 
  } 
  else 
  {
    year.disabled = true;
    series.disabled = true;
  }
}

function set_model_year_series(model, year, series) {
  var model_year_seriesArr;

  series.length = 0;
  series.options[0] = new Option('Select Series', '');
  
  var modelText = model.options[model.selectedIndex].text;
  var yearText = year.options[year.selectedIndex].text;
  if (series_years[modelText+"_"+yearText]) {
    series.disabled = false;
    
    model_year_seriesArr = series_years[modelText+"_"+yearText].split('|');
    for (var i = 0; i < model_year_seriesArr.length; i++)
      series.options[i + 1] = new Option(model_year_seriesArr[i], model_year_seriesArr[i]);
 
  } 
  else 
  {
    series.disabled = true;
  }
}


$('#submitFilter').click(function() {
  	var make = $("#make option:selected").text();
    var model = $("#model option:selected").text();
    model = model.replace(/^\s+|\s+$/g,"");
  	var year = $("#year option:selected").text();
    year = year.replace(/^\s+|\s+$/g,"");
  	var series = $("#series option:selected").text();
    series = series.replace(/^\s+|\s+$/g,"");
  
  
  var currentUrl = window.location.href;
  var indexOfCollections = currentUrl.indexOf("collections"); 
  
  if(indexOfCollections > 0)
  {  
  	var indexOfMake = currentUrl.indexOf("make");
  	if(indexOfMake > 0)
  	{
    	var indexOfPlusAfterMake = currentUrl.substring(indexOfMake, currentUrl.length).indexOf("+");
      
      	if(indexOfPlusAfterMake > 0)
        {
          currentUrl = currentUrl.substring(0, indexOfMake) + currentUrl.substring(indexOfMake, currentUrl.length).substring(indexOfPlusAfterMake, currentUrl.length);
        }
      	else
        {
        	currentUrl = currentUrl.substring(0, indexOfMake);  
        }
    }
    
    var indexOfModel = currentUrl.indexOf("model");
  	if(indexOfModel > 0)
  	{
    	var indexOfPlusAfterModel = currentUrl.substring(indexOfModel, currentUrl.length).indexOf("+");
      
      	if(indexOfPlusAfterModel > 0)
        {
          currentUrl = currentUrl.substring(0, indexOfModel) + currentUrl.substring(indexOfModel, currentUrl.length).substring(indexOfPlusAfterModel, currentUrl.length);
        }
      	else
        {
        	currentUrl = currentUrl.substring(0, indexOfModel);  
        }
    }
    
    var indexOfYear = currentUrl.indexOf("year");
  	if(indexOfYear > 0)
  	{
    	var indexOfPlusAfterYear = currentUrl.substring(indexOfYear, currentUrl.length).indexOf("+");
      
      	if(indexOfPlusAfterYear > 0)
        {
          currentUrl = currentUrl.substring(0, indexOfYear) + currentUrl.substring(indexOfYear, currentUrl.length).substring(indexOfPlusAfterYear, currentUrl.length);
        }
      	else
        {
        	currentUrl = currentUrl.substring(0, indexOfYear);  
        }
    }
    
    var indexOfSeries = currentUrl.indexOf("series");
  	if(indexOfSeries > 0)
  	{
    	var indexOfPlusAfterSeries = currentUrl.substring(indexOfSeries, currentUrl.length).indexOf("+");
      
      	if(indexOfPlusAfterSeries > 0)
        {
          currentUrl = currentUrl.substring(0, indexOfSeries) + currentUrl.substring(indexOfSeries, currentUrl.length).substring(indexOfPlusAfterSeries, currentUrl.length);
        }
      	else
        {
        	currentUrl = currentUrl.substring(0, indexOfSeries);  
        }
    }
    
    var strAfterCollections = currentUrl.substring(indexOfCollections + 12, currentUrl.length);
    
    if(strAfterCollections.indexOf("/") > 0)
      currentUrl = currentUrl + '+';
    else 
      currentUrl = currentUrl + '/';
    
  }
  else
  {
    currentUrl = 'https://myautopartsbsit.myshopify.com/collections/all/';
  }
  
  currentUrl = currentUrl.replace("++","");

  if(make != 'Select Make')
    currentUrl = currentUrl + '+make_'+ make.replace(/ /g,"-").replace(/\//g,"-");
  
  if(model != 'Select Model')
    currentUrl = currentUrl + '+model_'+ model.replace(/ /g,"-").replace(/\//g,"-");
    
  if(year != 'Select Year')
    currentUrl = currentUrl + '+year_'+ year.replace(/ /g,"-").replace(/\//g,"-");
  
  if(series != 'Select Series')
    currentUrl = currentUrl + '+series_'+ series.replace(/ /g,"-").replace(/\//g,"-");

    currentUrl = currentUrl.replace(/\+\+/g,"+");

  window.location.href = currentUrl;
  return false;
  
});